import Vue from 'vue'
import VueRouter, { NavigationGuard, RouterOptions } from 'vue-router'
import { Store } from 'vuex/types'
import { IRootState } from '@/store'
import types from '@/store/all-action-types'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "index" */ '@/views/Home.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "index" */ '@/views/Login.vue')
  },
  {
    path: '/create-password',
    name: 'CreatePassword',
    component: () => import(/* webpackChunkName: "index" */ '@/views/CreatePassword.vue')
  },
  {
    path: '/about',
    name: 'About',    
    component: () => import(/* webpackChunkName: "about" */ '@/views/Home.vue')
  },
  {
    path: '/partenaire',
    name: 'Partenaires',
    component: () => import(/* webpackChunkName: "partenaire" */ '@/views/partenaire/GestionPartenaires.vue')
  },
  {
    path: '/partenaire/:partenaireId',
    name: 'ModifyPartenaires',
    component: () => import(/* webpackChunkName: "partenaire" */ '@/views/partenaire/ModifyPartenaires.vue'),
    props(route: any) {              
      return { ...route.params, partenaireId:parseInt(route.params.partenaireId) }
    }
  },
  {
    path: '/flux',
    name: 'Flux',
    component: () => import(/* webpackChunkName: "flux" */ '@/views/flux/GestionFlux.vue')
  },
  {
    path: '/flux/:fluxId',
    name: 'ModifyFlux',
    component: () => import(/* webpackChunkName: "flux" */ '@/views/flux/ModifyFlux.vue'),
    props(route: any) {              
      return { ...route.params, fluxId:parseInt(route.params.fluxId) }
    }
  },
  {
    path: '/grc',
    name: 'GroupCarac',
    component: () => import(/* webpackChunkName: "flux" */ '@/views/carac/GroupCarac.vue')
  },
  {
    path: '/grc/:groupCaracId',
    name: 'ModifyGroupCarac',
    component: () => import(/* webpackChunkName: "flux" */ '@/views/carac/ModifyGroupCarac.vue'),
    props(route: any) {              
      return { ...route.params, groupCaracId:parseInt(route.params.groupCaracId) }
    }
  },   
  {
    path: '/profils',
    name: 'ProfilExclusion',
    component: () => import(/* webpackChunkName: "flux" */ '@/views/profils/GestionProfils.vue')
  },
  {
    path: '/profils/:profilExclusionId',
    name: 'ModifyProfilExclusion',
    component: () => import(/* webpackChunkName: "flux" */ '@/views/profils/ModifyProfils.vue'),
    props(route: any) {              
      return { ...route.params, profilExclusionId:parseInt(route.params.profilExclusionId) }
    }
  },  
  {
    path: '/outils/facettes',
    name: 'Facette',
    component: () => import(/* webpackChunkName: "facette" */ '@/views/facette/GestionFacette.vue')
  },
  {
    path: '/admin/personne',
    name: 'Personne',
    component: () => import(/* webpackChunkName: "personne" */ '@/views/personne/GestionPersonne.vue')
  },
  {
    path: '/admin/personne/:personneId',
    name: 'ModifyPersonne',
    component: () => import(/* webpackChunkName: "personne" */ '@/views/personne/ModifyPersonne.vue'),
    props(route: any) {              
      return { ...route.params, personneId:parseInt(route.params.personneId) }
    } 
  },
  {
    path: '/codic',
    name: 'GestionCodic',
    component: () => import(/* webpackChunkName: "codic" */ '@/views/codic/GestionCodic.vue')    
  },  
  { 
    path: '/admin/datasources',
    name: 'DataSources',
    component: () => import(/* webpackChunkName: "centralweb" */ '@/views/CentralWeb/datasources/GestionDataSources.vue')
  },
  {
    path: '/admin/datasources/:dsoId',
    name: 'ModifyDataSources',
    component: () => import(/* webpackChunkName: "centralweb" */ '@/views/CentralWeb/datasources/ModifyDataSources.vue'),
    props(route: any) {              
      return { ...route.params, dsoId:parseInt(route.params.dsoId) }
    }
  },
  {
    path: '/admin/metas',
    name: 'Metas',
    component: () => import(/* webpackChunkName: "centralweb" */ '@/views/CentralWeb/metas/GestionMetas.vue')
  },
  {
    path: '/admin/metas/:mtaId',
    name: 'ModifyMetas',
    component: () => import(/* webpackChunkName: "centralweb" */ '@/views/CentralWeb/metas/ModifyMetas.vue'),
    props(route: any) {              
      return { ...route.params, mtaId:parseInt(route.params.mtaId) }
    }
  },
  {
    path: '/admin/flux-builders',
    name: 'FluxBuilders',
    component: () => import(/* webpackChunkName: "centralweb" */ '@/views/CentralWeb/fluxBuilders/GestionFluxBuilders.vue')
  },
  {
    path: '/admin/flux-builders/:bldId',
    name: 'ModifyFluxBuilders',
    component: () => import(/* webpackChunkName: "centralweb" */ '@/views/CentralWeb/fluxBuilders/ModifyFluxBuilders.vue'),
    props(route: any) {              
      return { ...route.params, bldId:parseInt(route.params.bldId) }
    }
  },
  {
    path: '/admin/feed-downloads', 
    name: 'FeedDownloads',
    component: () => import(/* webpackChunkName: "centralweb" */ '@/views/CentralWeb/feedDownloads/GestionFeedDownloads.vue')
  },
  {
    path: '/admin/feed-downloads/:dldId',
    name: 'ModifyFeedDownloads',
    component: () => import(/* webpackChunkName: "centralweb" */ '@/views/CentralWeb/feedDownloads/ModifyFeedDownloads.vue'),
    props(route: any) {              
      return { ...route.params, dldId:parseInt(route.params.dldId) }
    }
  },
]

export default (store: Store<IRootState>) => {
  const router = new VueRouter({
    //mode: 'history',
    routes
  })

  //mise ne place de la securité test pour chaque route demandée
  router.beforeEach(((to, from, next) => {
    if (to.name == 'CreatePassword') {
      next()
      return
    }
    else if (to.name == 'Login') {
      //si on est pas authentifié on reste sur la page login
      if (!store.getters.isAuthenticated) {
        next()
        return
      }
      next('/')
    } else {
      //si on est authentifié c'est bon
      if (store.getters.isAuthenticated) {
        //on a pas encore lancé de renew automatique on est donc dans le cas d'un premier accès        
        next()        
        return
      }
      else{
        console.log("UI_SET_REDIRECT_PATH",to.path)
        store.dispatch(types.AUTH_SET_REDIRECT_PATH, to.path)
        store.dispatch(types.AUTH_USER_REQUEST)
            .then(() => {
              next()
            })
            .catch(() => {              
              next('/login')
            })
        return
      }     
    }
  }) as NavigationGuard)

  
  return router
}
